import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMastercomfigComponent } from './simple-icons-mastercomfig.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMastercomfigComponent ],
    exports:      [ SimpleIconsMastercomfigComponent ],
    bootstrap:    []
})
export class SimpleIconsMastercomfigModule {}
